<template>
  <div
    ref="scrollableContentWidth"
    class="ll-scrollable-block_wrap"
    :class="{
      bottom: bottom,
      transparent: transparent,
      'flex-center': isComingSoon || flexCenter,
      'flex-start': flexStart,
      'has-bg-image': bgImage,
    }"
    :style="bgImage ? {
      '--bg-image': 'url(' + bgImage + ')',
      '--bg-opacity': bgImageOpacity !== undefined ? bgImageOpacity : 1,
    } : {}"
  >
    <div
      v-if="title && !isComingSoon"
      class="title-wrap"
    >
      <WsText001
        h2
        bold
        :is-ellipsis2="isEllipsis2"
      >
        {{ $t(title) }}
      </WsText001>
      <p
        v-if="subTitle"
        class="title"
      >
        {{ $t(subTitle) }}
      </p>
      <slot name="title" />
      <div
        v-if="fixedButton"
        class="fixed-button"
        :class="{'no-fixed':noFixed}"
      >
        <slot name="fixed-button" />
      </div>
    </div>
    <slot name="sub-title" />
    <slot v-if="!isComingSoon" />
    <LlEmptyPic
      v-else
      :image="require('@/assets/image/img-empty/Blue-comingsoon.png')"
      big-title="Coming Soon"
    />
  </div>
</template>
<script>
export default {
  name: "LlScrollableBlock",
  props: {
    title: {
      type: String,
      default: "",
    },
    subTitle: {
      type: String,
      default: "",
    },
    fixedButton: {
      type: Boolean,
      default: false,
    },
    noFixed: {
      type: Boolean,
      default: false,
    },
    bottom: {
      type: Boolean,
      default: false,
    },
    isComingSoon: {
      type: Boolean,
      default: false,
    },
    isEllipsis2: {
      type: Boolean,
      default: true,
    },
    transparent: {
      type: Boolean,
      default: false,
    },
    flexCenter: {
      type: Boolean,
      default: false,
    },
    bgImage: {
      type: String,
    },
    bgImageOpacity: {
      type: Number,
      default: 1,
    },
    flexStart: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    width: 0,
    leftPosition: 0,
  }),
  created() {
    window.addEventListener("resize", this.$_getBottomBarWidth);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.$_getBottomBarWidth);
  },
  mounted() {
    this.$_getBottomBarWidth();
  },
  methods: {
    $_getBottomBarWidth() {
      if (!this.$refs.scrollableContentWidth && !this.bottom) {
        return null;
      }
      let contnetWidth =
        this.$refs.scrollableContentWidth.getBoundingClientRect();
      this.width = contnetWidth.width;
      this.leftPosition = contnetWidth.x;
      let widthPosition = {
        width: this.width,
        position: this.leftPosition,
      };
      this.$emit("width-position", widthPosition);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/component/ll-scrollable-block";
</style>